module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-4-blocks-a766d2a2e31974127bf7cdfbfa66a29d.svg";